import { mapGetters, mapState } from "vuex";

export const AbtestCurtainMixin = {
    props: {
        expId: {
            type: String
        },
		curtainStyles: {
			type: Object,
			default: () => ({})
		}
    },
	computed: {
		...mapState({
			hasResponse: state => state.consents.hasResponse
		}),
		...mapGetters("AbtestModule", ["isId", "isVariant", "hasSomeVariant", "isInitialized"]),
		...mapGetters(["isConsented"]),
		curtainStyle() {
		  return this.showCurtain ? { ...this.curtainStyles, visibility: "hidden" } : { visibility: "visible" };
		},
		participatesInTest: function() {
			return App.Eros.BackendConfig.abTest.enableFrontendAssignment || (this.hasResponse && this.isConsented("tracking.googleanalytics"));
		},
		showCurtain: function() {
			return typeof window === "undefined" || !this.isInitialized || (this.participatesInTest && !this.hasSomeVariant);
		},
		// showA: function() {
		// 	return (
		// 		!this.participatesInTest ||
		// 		((!this.expId || this.isId(this.expId)) && (this.isVariant("0") || !this.hasSomeVariant))
		// 	);
		// },
		showB: function() {
			return this.participatesInTest && (!this.expId || this.isId(this.expId)) && this.isVariant("1");
		}
	}
};
